// TODO FIXME - levantarlo de la DB
// el calendar esta fijo x el momento
const INITIAL_STATE = {
  school: {
    school_id: "200037",
    name: "Colegio Dr Salvador Sallares",
    email: "info@institutodrsallares.com.ar",
    fiscal_name: "INSTITUTO DOCTOR SALLARES S. A.",
    fiscal_id: "30709661724",
    image:
      "https://steduexdata01.blob.core.windows.net/publico/colegio_200037/logo.jpg?c=637136151618003170",
    calendars: [
      {
        calendar_id: "684F2530-8555-43F3-894B-A6CE01448042",
        school_id: "200037",
        name: "Ciclo lectivo 2016",
        start_date: "2016-02-01T03:00:00.000Z",
        end_date: "2017-01-31T03:00:00.000Z",
        status: "0",
        parent_id: null,
        short_name: "2016",
      },
      {
        calendar_id: "3FCB3E5A-59D7-49E7-BDC9-5043C5EDD5B8",
        school_id: "200037",
        name: "Ciclo lectivo 2017",
        start_date: "2017-02-01T03:00:00.000Z",
        end_date: "2018-01-31T03:00:00.000Z",
        status: "0",
        parent_id: "684F2530-8555-43F3-894B-A6CE01448042",
        short_name: "2017",
      },
      {
        calendar_id: "39EAF5F4-DA61-43B4-BFE1-BE246196DE38",
        school_id: "200037",
        name: "Ciclo lectivo 2018",
        start_date: "2018-02-01T03:00:00.000Z",
        end_date: "2019-01-31T03:00:00.000Z",
        status: "0",
        parent_id: "3FCB3E5A-59D7-49E7-BDC9-5043C5EDD5B8",
        short_name: "2018",
      },

      {
        calendar_id: "9CEB22C8-75E5-4E57-961B-92E2B2570952",
        school_id: "200037",
        name: "Ciclo lectivo 2019",
        start_date: "2019-02-01T03:00:00.000Z",
        end_date: "2020-01-31T03:00:00.000Z",
        status: "0",
        parent_id: "39EAF5F4-DA61-43B4-BFE1-BE246196DE38",
        short_name: "2019",
      },

      {
        calendar_id: "82DCD61C-5026-4B33-9EAA-0003CBF765CE",
        school_id: "200037",
        name: "Ciclo lectivo 2020",
        start_date: "2020-02-01T03:00:00.000Z",
        end_date: "2021-01-31T03:00:00.000Z",
        status: "0",
        parent_id: "9CEB22C8-75E5-4E57-961B-92E2B2570952",
        short_name: "2020",
      },
      {
        calendar_id: "2021D61C-5026-4B33-9EAA-0003CBF72021",
        school_id: "200037",
        name: "Ciclo lectivo 2021",
        start_date: "2021-02-01T03:00:00.000Z",
        end_date: "2022-01-31T03:00:00.000Z",
        status: "0",
        parent_id: "82DCD61C-5026-4B33-9EAA-0003CBF765CE",
        short_name: "2021",
      },
      {
        calendar_id: "20220000-5026-4B33-9EAA-000000002022",
        school_id: "200037",
        name: "Ciclo lectivo 2022",
        start_date: "2022-02-01T03:00:00.000Z",
        end_date: "2023-01-31T03:00:00.000Z",
        status: "0",
        parent_id: "2021D61C-5026-4B33-9EAA-0003CBF72021",
        short_name: "2022",
      },
      {
        calendar_id: "20230000-5026-4B33-9EAA-000000002023",
        school_id: "200037",
        name: "Ciclo lectivo 2023",
        start_date: "2023-02-01T03:00:00.000Z",
        end_date: "2024-01-31T03:00:00.000Z",
        status: "1",
        parent_id: "20220000-5026-4B33-9EAA-000000002022",
        short_name: "2023",
      },
      {
        calendar_id: "20240000-5026-4B33-9EAA-000000002024",
        school_id: "200037",
        name: "Ciclo lectivo 2024",
        start_date: "2024-02-01T03:00:00.000Z",
        end_date: "2025-01-31T03:00:00.000Z",
        status: "0",
        parent_id: "20230000-5026-4B33-9EAA-000000002023",
        short_name: "2024",
      },
      {
        calendar_id: "20250000-5026-4B33-9EAA-000000002025",
        school_id: "200037",
        name: "Ciclo lectivo 2025",
        start_date: "2025-02-01T03:00:00.000Z",
        end_date: "2026-01-31T03:00:00.000Z",
        status: "0",
        parent_id: "20240000-5026-4B33-9EAA-000000002024",
        short_name: "2025",
      },
      {
        calendar_id: "20260000-5026-4B33-9EAA-000000002026",
        school_id: "200037",
        name: "Ciclo lectivo 2026",
        start_date: "2026-02-01T03:00:00.000Z",
        end_date: "2027-01-31T03:00:00.000Z",
        status: "0",
        parent_id: "20250000-5026-4B33-9EAA-000000002025",
        short_name: "2026",
      },
      {
        calendar_id: "20270000-5026-4B33-9EAA-000000002027",
        school_id: "200037",
        name: "Ciclo lectivo 2027",
        start_date: "2027-02-01T03:00:00.000Z",
        end_date: "2028-01-31T03:00:00.000Z",
        status: "0",
        parent_id: "20260000-5026-4B33-9EAA-000000002026",
        short_name: "2027",
      },
    ],
  },
};

export function config(state = INITIAL_STATE, action) {
  switch (action.type) {
    default:
      return state;
  }
}
